import fetch from 'utils/fetch';

export const EA_LOGOUT_URL = '/ea/ipims/logout';
export const IPIMS_LOGOUT_URL = `${PLATFORM.PANDA}/saml/logout?local=true`;
export const OKTA_LOGOUT_URL = 'https://rapid7.okta.com';

export const getLogoutPageUrl = ({
  consoleUrl,
  hasConsoleSession,
  hasIpimsSession,
  isDev,
  isFromR7Okta = false,
  isSSOEnabled = false,
}) => {
  if (isFromR7Okta && !isDev) {
    return OKTA_LOGOUT_URL;
  }

  //the console cleans up the ipims session as well if both sessions are present
  if (hasConsoleSession && consoleUrl) {
    return `${consoleUrl}/logout.html${
      isSSOEnabled ? '?redirect=platform' : ''
    }`;
  }

  if (hasIpimsSession && PLATFORM.PANDA) {
    return IPIMS_LOGOUT_URL;
  }

  return '';
};

export default function getLogoutAction({
  consoleUrl,
  hasConsoleSession,
  hasIpimsSession,
  isDev,
  isFromR7Okta = false,
  isSSOEnabled = false,
  userExists = false,
}) {
  const url = getLogoutPageUrl({
    consoleUrl,
    hasConsoleSession,
    hasIpimsSession,
    isDev,
    isFromR7Okta,
    isSSOEnabled,
  });

  let logout = null;

  if (userExists) {
    logout = () =>
      fetch({
        method: 'POST',
        url: EA_LOGOUT_URL,
      })
        .then(() => {
          // eslint-disable-next-line no-console
          console.log('InsightVM logged out');
        })
        .catch((xhr, status, error) => {
          // eslint-disable-next-line no-console
          console.error(`Call failed, ${status}, error: ${error}`);
        })
        .finally(() => {
          if (url) {
            window.location.replace(url);
          } else if (isDev) {
            window.alert('Logged out of InsightVM');
          }
        });
  }

  return {logout, url};
}
